var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 82,
    viewBox: "0 0 95 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6823 46.8131C55.8008 47.1236 54.349 47.1236 53.4676 46.8131C45.9493 44.2522 29.1499 33.5685 29.1499 15.4605C29.1499 7.46713 35.6052 1 43.5642 1C48.2826 1 52.4565 3.27643 55.0749 6.79455C57.6934 3.27643 61.8932 1 66.5856 1C74.5446 1 81 7.46713 81 15.4605C81 33.5685 64.2005 44.2522 56.6823 46.8131Z",
    stroke: "#45B14A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0254 47.9165H28.6C29.5375 47.9165 30.4654 48.1048 31.3287 48.4703L45.0408 54.2748C45.5342 54.4836 46.0644 54.5912 46.6001 54.5912H59.3325C61.1992 54.5912 62.8178 55.8825 63.2325 57.7026L64.2648 62.2333",
    stroke: "#132A3A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8319 73.5512V73.6782C17.8319 76.4396 15.5933 78.6782 12.8319 78.6782H3C1.89543 78.6782 1 77.7828 1 76.6782V44.9829C1 43.8783 1.89543 42.9829 3 42.9829H12.8319C15.5933 42.9829 17.8319 45.2215 17.8319 47.9829V73.5512ZM17.8319 73.5512H24.2164L45.5503 79.7736C48.2501 80.561 51.1489 80.2845 53.6511 79.0009L90.7341 59.9779C92.7537 58.9418 93.4951 56.4263 92.3602 54.4605V54.4605C91.2255 52.4953 88.7976 51.6932 86.7157 52.5959L61.3628 63.5875H41.919",
    stroke: "#132A3A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindCare);
export default __webpack_public_path__ + "static/media/find-care.6ed5c71cb34be981c38c85ac0d9cf958.svg";
export { ForwardRef as ReactComponent };